import { CalendarShop } from "../../../../../shop/frontend/web/js/classes/CalendarShop.js";

export class Calendar extends CalendarShop {
	constructor() {
		super();
	}
}
